import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import AxiosApiClient from '../utils/AxiosApiClient';
import AuthUtility from './auth/AuthUtility';
import LoadingSpinner from './LoadingSpinner';
import ListenLive from './ListenLive';
import SharingPodcastRSS from './SharingPodcastRSS';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

import feliz_1_image from '../../assets/frontend/images/feliz_1.jpg';
import feliz_2_image from '../../assets/frontend/images/feliz_2.png';
import feliz_podcast_image from '../../assets/frontend/images/feliz_podcast.jpg';

const error_style = 'font-source-sans font-size-12 font-weight-500 txt-000 bg-light-red p-5';

const Home = () => {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = React.useState(false);
	const [contactInput, setContact] = useState({
		first_name: '',
		last_name: '',
		phone: '',
		email: '',
		option: 'prayer_request',
		message: '',
		errorList: [],
		errorStyle: [],
	});

	const handleInput = (event) => {
		event.persist();

		setContact({ ...contactInput, [event.target.name]: event.target.value });

		//remove the target error message no matter the new input, it will be validated on the server
		if (contactInput.errorList.hasOwnProperty(event.target.name)) {
			delete contactInput.errorList[event.target.name];
			delete contactInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}

	const contactSubmit = (event) => {
		event.preventDefault();

		setIsLoading(true);

		//values sent to api
		const payload = {
			first_name: contactInput.first_name,
			last_name: contactInput.last_name,
			email: contactInput.email,
			phone: contactInput.phone,
			option: contactInput.option,
			message: contactInput.message,
		}

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/contact', payload, {});

				setApiData(response, "contactSubmit");
			} catch (error) {
				handleApiError(error, "contactSubmit");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.api_message);

				//sweet alert on next page
				swal("Success", response.data.api_message, "success");
				navHistory('/');

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				swal("Warning", response.data.message, "warning");
			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

				var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
				Object.keys(errorStyleTemp).map((key) => (
					errorStyleTemp[key] = error_style
				));
				Object.keys(errorStyleTemp).map((key) => (
					$('#' + key + '_message').addClass('hide') //clear any previous message
				));

				//validation errors mapped to input fields
				setContact({ ...contactInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });

			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
	}


	return (
		<div className="body-content bg-feliz-pink pb-80">

			<div className="bg-feliz-pink feliz-section p-40l-30m-20s text-center">
				<div className="panel large b1-ccc">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
							<div class="divider-text font-sacramento-regular font-size-40l-34m-28s font-weight-500">
							Feliz Love and Light
							</div>
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per pt-20l-10s">
								Helping you grow your God-given gifts to impact your community.
							</div>
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per pt-20l-10s">
								<img src={feliz_1_image} alt="Feliz Garcia" className="img-responsive-50per-100per b5-fff" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="bg-feliz-blue feliz-section p-40l-30m-20s text-center">
				<div className="panel large b1-ccc">
					<div className="grid-x">

						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s pb-10">
							<div class="divider-text-white font-sacramento-regular font-size-40l-34m-28s font-weight-500 txt-fff">
							About Feliz Love and Light
							</div>
						</div>
						<div className="large-6 medium-12 small-12 cell text-center pt-20l-10s pr-10l-0s">
							<img src={feliz_2_image} alt="Feliz Garcia" className="img-responsive b5-fff" />
						</div>
						<div className="large-6 medium-12 small-12 cell text-center pt-20l-10s pl-10l-0s">
							<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-justify line-height-125per">
							Mission
							</div>
							<div className="font-raleway font-size-24l-20m-18s text-000 txt-fff text-justify line-height-125per pt-20l-10s">
							I'm Feliz Garcia a podcast host, radio DJ, and founder of Feliz Love and Light™. After rediscovering my purpose through faith and motherhood, I felt called to build a business led by the Holy Spirit. Now, I help others embrace their God-given gifts to impact their communities and live with purpose.
							</div>
							<div className="font-raleway font-size-24l-20m-18s txt-fff text-justify line-height-125per pt-20l-10s">
							My goal is to help bring God back into our daily lives, reminding us that when we surrender to His plan, the future is even more beautiful than we could ever imagine. This journey has been such a blessing, and I’m grateful for the time I now have to be with my girls and to build a business led by the Holy Spirit. My hope is to inspire others to lean into the gifts that God gave them and create spaces for innovation that will benefit their communities, making this world a peaceful, loving, and united place. 							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="bg-feliz-pink feliz-section p-40l-30m-20s text-center">
				<div className="panel large b1-ccc">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
							<div class="divider-text font-sacramento-regular font-size-40l-34m-28s font-weight-500  line-height-125per">
							Light The Way: <br className="show-for-small-only"></br>Faith, Love, & Music Radio 							
							</div>
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per pt-20l-10s">
							<ListenLive />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="bg-feliz-blue feliz-section p-40l-30m-20s text-center">
				<div className="panel large b1-ccc">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s pb-10">
							<div class="divider-text-white font-sacramento-regular font-size-40l-34m-28s font-weight-500 txt-fff">
							Podcast
							</div>
						</div>

						<div className="large-4 medium-4 small-12 cell text-center pr-10l-0s">
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per pt-20l-10s">
							<img src={feliz_podcast_image} alt="Feliz Garcia" className="img-responsive b5-fff" />
							</div>
							<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-fff text-justify line-height-125per pt-20l-10s">
							About Podcast
							</div>
							<div className="font-raleway font-size-24l-20m-18s txt-fff text-justify line-height-125per pt-20l-10s">
							My vision is to build a community of Love, Light, Spirituality, Joy, Purpose, and Happiness. My mission is to inspire personal transformation and create a heaven on earth through heartfelt conversations, powerful stories, and transformative insights. Join us each week as we explore the depths of what it means to live a fulfilled and enlightened life. Whether we're delving into spiritual practices, sharing personal triumphs, or discussing life's challenges, our podcast is a sanctuary for those seeking to infuse more love and positivity into their lives.
							</div>
						</div>
						
						<div className="large-8 medium-8 small-12 cell text-center pl-10l-0s">
							<SharingPodcastRSS />
						</div>
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
							<div class="divider-text-white font-sacramento-regular font-size-40l-34m-28s font-weight-500 txt-fff pt-20l-10s">
							Social
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="bg-feliz-pink feliz-section p-40l-30m-20s text-center">
				<div className="panel large b1-ccc">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
							<div class="divider-text font-sacramento-regular font-size-40l-34m-28s font-weight-500">
							Join Our Community 							
							</div>
							<div className="font-raleway font-size-24l-20m-18s text-000 text-justify line-height-125per pt-20l-10s">
							We would love to hear from you. Whether you have a prayer request, a song suggestion, a story to share, or would like to connect with our ministry, we are here.
							</div>
						</div>
					</div>
					
					<form onSubmit={contactSubmit}>
					<div className="grid-x bg-fafafa b2-000 p-20l-10s mt-20l-10s">
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.first_name}>{contactInput.errorList.first_name}</div>
							<div className="p-5" id="first_name_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-user txt-555"></span></span>
								<input type="text" name="first_name" onChange={handleInput} value={contactInput.first_name} className="input-group-fieldx" placeholder="First Name" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
							<div className={contactInput.errorStyle.last_name}>{contactInput.errorList.last_name}</div>
							<div className="p-5" id="last_name_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-user txt-555"></span></span>
								<input type="text" name="last_name" onChange={handleInput} value={contactInput.last_name} className="input-group-field" placeholder="Last Name" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.email}>{contactInput.errorList.email}</div>
							<div className="p-5" id="email_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-envelope txt-555"></span></span>
								<input type="text" name="email" onChange={handleInput} value={contactInput.email} className="input-group-field" placeholder="Email" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
							<div className={contactInput.errorStyle.phone}>{contactInput.errorList.phone}</div>
							<div className="p-5" id="phone_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-lock txt-555"></span></span>
								<input type="text" name="phone" onChange={handleInput} value={contactInput.phone} className="input-group-field" placeholder="Phone" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.option}>{contactInput.errorList.option}</div>
							<div className="p-5" id="option_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-lock txt-555"></span></span>
								<select	name="option" onChange={handleInput} value={contactInput.option}>
									<option key="1" value="prayer_request">Prayer Request</option>
									<option key="2" value="song_request">Song Request</option>
									<option key="3" value="podcast_request">Podcast Request</option>
									<option key="4" value="radio_show_interview_request">Radio Show Interview Request</option>
									<option key="5" value="share_my_story">Share My Story</option>
									<option key="6" value="encouragement_or_feedback">Encouragement or Feedback</option>
									<option key="7" value="general_question">General Question</option>
									<option key="8" value="other">Other</option>
								</select>
							</div>
						</div>
						<div className="large-12 medium-12 small-12 cell text-left">
							<div className={contactInput.errorStyle.message}>{contactInput.errorList.message}</div>
							<div className="p-5" id="message_message">&nbsp;</div>
							<div className="input-group">
								<textarea name="message" onChange={handleInput} value={contactInput.message} className="input-group-field" placeholder="Share your prayer request, message, story, song request, or how we can serve you." />
							</div>
						</div>
						<div className="large-12 medium-12 small-12 cell text-right">
							<div className="horizontal-container justify-right">
								{isLoading &&
									<span className="element pr-10">
										<LoadingSpinner paddingclassName="none" sizeclassName="none" />
									</span>
								}
								<span className="element">
									{/*
									<button type="submit" className="button width-125px-100px">Submit</button>
									*/}
								</span>
							</div>
						</div>
					</div>
					</form>
					
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
							<div className="font-raleway font-size-24l-20m-18s text-000 text-center line-height-125per pt-20l-10s">
							Feliz Love and Light&trade; | <Link to="mailto:felizlovelight@gmail.com">felizlovelight@gmail.com</Link>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>

	);
}

export default Home;